module.exports = __webpack_public_path__ + "img/media-a9vg@2x.08f9bca2.png";